export default __webpack_public_path__ + "static/media/black_friday_2025_campaign_dashboard.da0cadcb.png";